<ng-container *ngIf="isReady$ | async">
  <ng-container *ngIf="type === WidgetTypeEnum.Button">
    <widget-santander-dk-button
      [amount]="amount"
      [channelSet]="channelSet"
      [config]="config"
      (clicked)="onClicked()"
      (failed)="onFailed()"></widget-santander-dk-button>
  </ng-container>
  <ng-container *ngIf="type === WidgetTypeEnum.DropdownCalculator">
    <widget-santander-dk-dropdown-calculator
      [amount]="amount"
      [channelSet]="channelSet"
      [config]="config"
      (clicked)="onClicked()"
      (failed)="onFailed()"></widget-santander-dk-dropdown-calculator>
  </ng-container>
  <ng-container *ngIf="type === WidgetTypeEnum.Text">
    <widget-santander-dk-text
      [amount]="amount"
      [channelSet]="channelSet"
      [config]="config"
      (clicked)="onClicked()"
      (failed)="onFailed()"></widget-santander-dk-text>
  </ng-container>
  <ng-container *ngIf="type === WidgetTypeEnum.TwoFieldsCalculator">
    <widget-santander-dk-two-fields-calculator
      [amount]="amount"
      [channelSet]="channelSet"
      [config]="config"
      (clicked)="onClicked()"
      (failed)="onFailed()"></widget-santander-dk-two-fields-calculator>
  </ng-container>
</ng-container>
